import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=4ef2c72e&scoped=true"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=4ef2c72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2c72e",
  null
  
)

export default component.exports